import i18next from 'i18next';

i18next.addResources('es_CL', 'ModalUseCoupon', {
  title: '¡Tus cupones te están esperando!',
  description:
    'Los cupones están disponibles solo para usuarios registrados. Inicia sesión o crea una cuenta para descubrir los descuentos que tienes asignados.'
});
